import styled from 'styled-components';
import { Modal } from 'lib/components/Modal/Modal';

export const StyledMachineUnclaimModal = styled(Modal)`
  width: 1024px !important;
  .ant-modal-footer {
    justify-content: space-between;
  }
`;
